<template>
    <main class="container-fluid" style="max-width: 500px">
      <div class="row m-3" v-if="erro">
        <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
            <span v-html="erro"></span>
        </div>
      </div>
  
      <div class="card my-3 px-3 py-3 shadow">
        <div style="display: flex; justify-content: space-between;" class="align-items-center">
            <div>
                <h4 class="my-3">Agendamentos</h4>
            </div>
            <div>
                <button class="btn w-100 " type="button" @click="irParaAgendarConsulta">
                    Agendar consulta
                </button>
            </div>
        </div>
        <div class="card my-3 px-3 py-3 shadow" v-if="listaAgendamentos && listaAgendamentos.length > 0">
            <div v-for="agendamento in listaAgendamentos" :key="agendamento.idAgendamento">
              <div class="card mb-3">
                <div class="card-body">
                  <h5 class="card-title"><strong>Dia: </strong>{{ formatarDataHora(agendamento.dataHoraAgendamento) }}</h5>
                  <p class="card-text"><strong>Especialidade: </strong>  {{ agendamento.nomeEspecialidade }}</p>
                  <p v-if="agendamento.status != 'CANCELADO' && agendamento.status != 'REAGENDADO' && agendamento.status != 'EXPIRADO' && agendamento.status != 'FINALIZADO'"  class="card-text">
                    <strong>URL da Consulta: </strong>
                    <a :href="agendamento.urlVideoConsulta" target="_blank">{{ agendamento.urlVideoConsulta }}</a>
                  </p>
                  <div style="display: flex; justify-content: center;" class="align-items-center">
                    <div>
                        <button v-if="agendamento.status != 'CANCELADO' && agendamento.status != 'REAGENDADO' && agendamento.status != 'EXPIRADO' && agendamento.status != 'FINALIZADO'" class="btn w-100 mr-4" type="button" @click="cancelarAgendamento(agendamento)">
                            Cancelar
                        </button>
                    </div>
                    <div>
                        <button v-if="agendamento.status != 'CANCELADO' && agendamento.status != 'REAGENDADO' && agendamento.status != 'EXPIRADO' && agendamento.status != 'FINALIZADO'" class="btn w-100 ml-4" type="button" @click="reagendarAgendamento(agendamento)">
                            Reagendar
                        </button>
                    </div>
                    <div>
                        <button v-if="agendamento.status == 'CANCELADO'" class="btn w-100" type="button" disabled >
                            Cancelado
                        </button>
                        <button v-if="agendamento.status == 'REAGENDADO'" class="btn w-100" type="button" disabled >
                            Reagendado
                        </button>
                        <button v-if="agendamento.status == 'EXPIRADO'" class="btn w-100" type="button" disabled >
                            Expirado
                        </button>
                        <button v-if="agendamento.status == 'FINALIZADO'" class="btn w-100" type="button" disabled >
                            Finalizado
                        </button>
                    </div>
                </div>
                </div>
              </div>
            </div>
        </div>
        <div class="card my-3 px-3 py-3 shadow" v-else>
            <div class="card-body">
                <p class="card-text">Não existem consultas agendadas.</p>
            </div>
        </div>
      </div>      
      <Loading v-if="loading"></Loading>
    </main>
  </template>
  
  <script>
  import { APITeleMedicinaService } from "@/service/tele-medicina/APITeleMedicinaService";
  const apiTeleMedicinaService = new APITeleMedicinaService();
  import Loading from "@/components/Loading.vue";
  import moment from "moment";
  import { mapActions } from 'vuex';
  
  export default {
    name: "VisualizarAgendamentos",
    components: {
      Loading,
    },
    data() {
      return {
        MODULOS: window.MODULOS,
        showUserInput: true,
        loading: false,
        erro: "",
        listaAgendamentos: null,
        cancelarAgendamentoResponse: null
      };
    },
    created() {
      this.obterAgendamentos();
    },
    methods: {
        obterAgendamentos(){
            this.loading = true;
            apiTeleMedicinaService.obterAgendamentos().then(response => {
                this.listaAgendamentos = response;
                this.verificarAgendamentosExpirados();
                this.loading = false;
            }).catch(error => {
                error;
                this.erro = "Erro ao carregar os agendamentos. <br> Por favor, tente novamente mais tarde.";
                this.loading = false;
            });
        },
        irParaAgendarConsulta(){
            this.$router.push(`/servico/tele-medicina/agendamento`);         
            window.scrollTo(0, 0);
        },
        formatarDataHora(dataHora) {
            return moment(dataHora).format('DD-MM-YYYY [às] HH:mm');
        },
        cancelarAgendamento(agendamento){
            this.loading = true;
            apiTeleMedicinaService.cancelarAgendamento(agendamento.idAgendamento).then(response => {
                this.cancelarAgendamentoResponse = response;
                this.$router.push(`/servico/tele-medicina/agendamento-cancelado`);         
                window.scrollTo(0, 0);
            }).catch(error => {
                this.loading = false;
                if (error.response && error.response.data && error.response.data.detail) {
                    const erroDetail = error.response.data.detail;
                    const erroSemPrefixo = erroDetail.replace('Bad Request - ', '');
                    this.erro = erroSemPrefixo;
                } else {
                    this.erro = 'Erro ao cancelar agendamento: Detalhe do erro não encontrado.';
                }
                window.scrollTo(0, 0);
            });
        },   
        ...mapActions(['setReagendartemp']),
        reagendarAgendamento(agendamento){
            const reagendartemp = {
                idAgendamento: agendamento.idAgendamento,
                idEspecialidade: agendamento.idEspecialidade
            }
            this.setReagendartemp(reagendartemp);
            this.$router.push({path: '/servico/tele-medicina/agendamento'});     
            window.scrollTo(0, 0);
        },
        ordenarPorHorario(agendamentos) {
            return agendamentos.sort((a, b) => {
                if (a.status !== b.status) {
                    return a.status === "CANCELADO" ? 1 : -1;
                }
                return new Date(a.dataHoraAgendamento) - new Date(b.dataHoraAgendamento);
            });
        },
        verificarAgendamentosExpirados() {
            const dataAtual = new Date();
            const margemDeTempo = 30;

            dataAtual.setMinutes(dataAtual.getMinutes() - margemDeTempo);

            this.listaAgendamentos.forEach(agendamento => {
                const dataAgendamento = new Date(agendamento.dataHoraAgendamento);
                if (dataAgendamento < dataAtual) {
                    if (dataAgendamento.getDate() === dataAtual.getDate()) {
                        if (dataAgendamento.getHours() < dataAtual.getHours() || (dataAgendamento.getHours() === dataAtual.getHours() && dataAgendamento.getMinutes() <= dataAtual.getMinutes())) {
                            agendamento.status = 'EXPIRADO';
                        }
                    } else {
                        agendamento.status = 'EXPIRADO';
                    }
                }
            });
        },
    }
  };
  </script>
  
  <style scoped lang="scss">
  button {
    background: var(--cor-principal);
    color: var(--cor-texto);
  }
  
  .btn-secondary {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
  }
  
  .a-divider.a-divider-break {
    text-align: center;
    position: relative;
    top: 2px;
    padding-top: 1px;
    margin-bottom: 14px;
    line-height: 0;
  
    &:after {
      content: "";
      width: 100%;
      background-color: transparent;
      display: block;
      height: 1px;
      border-top: 1px solid #e7e7e7;
      position: absolute;
      top: 50%;
      margin-top: -1px;
      z-index: 1;
    }
  
    h5 {
      line-height: 1;
      font-size: 12px;
      color: #767676;
      font-weight: 400;
      z-index: 2;
      position: relative;
      display: inline-block;
      background-color: #fff;
      padding: 0 8px 0 7px;
    }
  }
  </style>
  